// // services/authApi.js
// import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
// import { API_BASE_URL } from '../../config';

// export const authApi = createApi({
//     reducerPath: 'authApi',
//     baseQuery: fetchBaseQuery({ baseUrl: API_BASE_URL + '/api' }), // укажи нужный URL
//     endpoints: (builder) => ({
//         login: builder.mutation({
//             query: ({ email, password }) => ({
//                 url: '/app/auth/login',
//                 method: 'POST',
//                 body: { email, password },
//             }),
//         }),
//         register: builder.mutation({
//             query: ({ email, phone, password }) => ({
//                 url: '/app/auth/register',
//                 method: 'POST',
//                 body: { email, phone, password },
//             }),
//         }),
//         forgotPassword: builder.mutation({
//             query: ({ email }) => ({
//                 url: '/app/auth/forgotPassword',
//                 method: 'POST',
//                 body: { email },
//             }),
//         }),
//         resetPassword: builder.mutation({
//             query: ({ email, password }) => ({
//                 url: '/app/auth/resetPassword',
//                 method: 'POST',
//                 body: { email, password },
//             }),
//         }),
//         checkEmail: builder.mutation({
//             query: ({ email }) => ({
//                 url: '/app/auth/check-email',
//                 method: 'POST',
//                 body: { email },
//             }),
//         }),
//         checkActivationCode: builder.query({
//             query: ({ activationCode, email }) => ({
//                 url: "/app/auth/checkActivationCode",
//                 method: "GET",
//                 params: { activationCode, email },
//             }),
//         }),
//         resendActivationCode: builder.mutation({
//             query: ({ email }) => ({
//                 url: "/app/auth/resendActivationCode",
//                 method: "POST",
//                 body: { email },
//             }),
//         }),
//         refreshToken: builder.mutation({
//             query: (body) => ({
//                 url: "/auth/refresh",
//                 method: "POST",
//                 body,
//             }),
//         }),
//     }),
// });

// export const {
//     useLoginMutation,
//     useRegisterMutation,
//     useLazyCheckActivationCodeQuery,
//     useResendActivationCodeMutation,
//     useResetPasswordMutation,
//     useCheckEmailMutation,
//     useForgotPasswordMutation,
//     useRefreshTokenMutation
// } = authApi;


// services/authApi.js
// services/authApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_BASE_URL } from "../../config";

// Базовый запрос с автоматическим добавлением accessToken
const baseQuery = fetchBaseQuery({
    baseUrl: API_BASE_URL + "/api",
    prepareHeaders: (headers) => {
        const token = localStorage.getItem("accessToken");
        if (token) headers.set("Authorization", `Bearer ${token}`);
        return headers;
    },
});

// Обёртка для авто-refresh
const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);

    if (result.error && result.error.status === 401) {
        // Если accessToken истёк — пробуем refresh
        const refreshToken = localStorage.getItem("refreshToken");
        if (!refreshToken) {
            api.dispatch({ type: "auth/logout" });
            return result;
        }

        const refreshResult = await baseQuery(
            {
                url: "/auth/refresh",
                method: "POST",
                body: { refreshToken },
            },
            api,
            extraOptions
        );

        if (refreshResult.data) {
            // Сохраняем новые токены
            localStorage.setItem("accessToken", refreshResult.data.accessToken);
            localStorage.setItem("refreshToken", refreshResult.data.refreshToken);

            // Повторяем исходный запрос с новым токеном
            result = await baseQuery(args, api, extraOptions);
        } else {
            // Refresh тоже недействителен → логаут
            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");
            api.dispatch({ type: "auth/logout" });
        }
    }

    return result;
};

// RTK Query API
export const authApi = createApi({
    reducerPath: "authApi",
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        login: builder.mutation({
            query: ({ email, password }) => ({
                url: "/app/auth/login",
                method: "POST",
                body: { email, password },
            }),
        }),
        register: builder.mutation({
            query: ({ email, phone, password }) => ({
                url: "/app/auth/register",
                method: "POST",
                body: { email, phone, password },
            }),
        }),
        forgotPassword: builder.mutation({
            query: ({ email }) => ({
                url: "/app/auth/forgotPassword",
                method: "POST",
                body: { email },
            }),
        }),
        resetPassword: builder.mutation({
            query: ({ email, password }) => ({
                url: "/app/auth/resetPassword",
                method: "POST",
                body: { email, password },
            }),
        }),
        checkEmail: builder.mutation({
            query: ({ email }) => ({
                url: "/app/auth/check-email",
                method: "POST",
                body: { email },
            }),
        }),
        checkActivationCode: builder.query({
            query: ({ activationCode, email }) => ({
                url: "/app/auth/checkActivationCode",
                method: "GET",
                params: { activationCode, email },
            }),
        }),
        resendActivationCode: builder.mutation({
            query: ({ email }) => ({
                url: "/app/auth/resendActivationCode",
                method: "POST",
                body: { email },
            }),
        }),
        refreshToken: builder.mutation({
            query: (body) => ({
                url: "/auth/refresh",
                method: "POST",
                body,
            }),
        }),
        agreements: builder.query({
            query: () => ({
                url: "/app/auth/agreement",
                method: "GET",
            }),
            providesTags: ["agreement"],
        }),
        agreement: builder.mutation({
            query: (body) => ({
                url: "/app/auth/agreement",
                method: "POST",
                body,
            }),
        }),
    }),
});

// Экспорт хуков
export const {
    useLoginMutation,
    useRegisterMutation,
    useLazyCheckActivationCodeQuery,
    useResendActivationCodeMutation,
    useResetPasswordMutation,
    useCheckEmailMutation,
    useAgreementsQuery,
    useAgreementMutation,
    useForgotPasswordMutation,
    useRefreshTokenMutation,
} = authApi;
